module.exports = __webpack_public_path__ + "static_pc/img/marquee3.ea7683f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/marquee3.jpg
// module id = Sj6I
// module chunks = 1